import React from 'react';

const StatCard = ({ label, value, subtext, color, icon: Icon, iconColor, gradient, trend, trendValue }) => {
  return (
    <div style={{
      background: 'var(--color-background-primary)',
      border: '1px solid var(--color-border-tertiary)',
      borderRadius: 'var(--border-radius-xl)',
      padding: '24px',
      flex: 1,
      position: 'relative',
      overflow: 'hidden',
      boxShadow: 'var(--shadow-sm)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      cursor: 'default',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = 'var(--shadow-md)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
    }}>
      {/* Gradient Top Bar */}
      {gradient && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: gradient
        }} />
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{
            fontSize: '14px',
            color: 'var(--color-text-secondary)',
            marginBottom: '12px',
            fontWeight: '600'
          }}>
            {label}
          </div>
          
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
            <div style={{
              fontSize: '32px',
              fontWeight: '700',
              color: color || 'var(--color-text-primary)',
              lineHeight: '1',
              letterSpacing: '-0.02em'
            }}>
              {value !== undefined && value !== null ? value : '-'}
            </div>
            
            {trend && trendValue && (
              <div style={{
                fontSize: '12px',
                fontWeight: '600',
                color: trend === 'up' ? 'var(--chart-green)' : 'var(--chart-orange)',
                display: 'flex',
                alignItems: 'center',
                gap: '2px'
              }}>
                {trend === 'up' ? '↑' : '↓'} {trendValue}
              </div>
            )}
          </div>

          {subtext && (
            <div style={{
              fontSize: '13px',
              color: 'var(--color-text-tertiary)',
              marginTop: '8px'
            }}>
              {subtext}
            </div>
          )}
        </div>

        {Icon && (
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: iconColor ? `${iconColor}15` : 'var(--color-background-info)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: iconColor || 'var(--color-brand-primary)'
          }}>
            <Icon size={24} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
